import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold text-gray-900">Privacy Policy</h1>
          <Link to="/" className="text-sm text-indigo-600 hover:text-indigo-700">
            Back to Home
          </Link>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed">
          This Privacy Policy explains how Songzug collects, uses, and protects your
          personal information. Please review this page regularly for updates.
        </p>
        <div className="mt-4 space-y-3 text-sm text-gray-600">
          <p><strong>Information We Collect:</strong> Basic profile data, usage analytics, and content you share.</p>
          <p><strong>How We Use It:</strong> To provide services, improve features, and keep your account secure.</p>
          <p><strong>Data Protection:</strong> We apply security best practices to safeguard your information.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
